import { useColorMode } from '@chakra-ui/react';
import { JSX, memo, useEffect } from 'react';

const ThemeColor: React.FC = (): JSX.Element => {
  const { colorMode } = useColorMode();

  useEffect(() => {
    const metaThemeColor = document.querySelector('meta[name=theme-color]');
    if (metaThemeColor) {
      if (colorMode === 'dark') {
        metaThemeColor.setAttribute('content', '#101828');
      } else {
        metaThemeColor.setAttribute('content', '#FFFFFF');
      }
    }
  }, [colorMode]);

  return null;
};

export default memo(ThemeColor);
